import { render, staticRenderFns } from "./ResourceRow.vue?vue&type=template&id=1e1b6758&scoped=true"
import script from "./ResourceRow.vue?vue&type=script&lang=js"
export * from "./ResourceRow.vue?vue&type=script&lang=js"
import style0 from "./ResourceRow.vue?vue&type=style&index=0&id=1e1b6758&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b6758",
  null
  
)

export default component.exports